import { useLayoutEffect, useRef, useState } from 'react';

const BASE_Z_INDEX = 1050;
const activeStack: number[] = [];

function claimZIndex(): number {
    const next = activeStack.length > 0 ? Math.max(...activeStack) + 1 : BASE_Z_INDEX + 1;
    activeStack.push(next);
    return next;
}

function releaseZIndex(z: number): void {
    const i = activeStack.indexOf(z);
    if (i !== -1) activeStack.splice(i, 1);
}

/**
 * Returns the z-index to apply to a modal element.
 * Claims a slot from the global stack when open, releases it when closed or unmounted.
 */
export function useModalZIndex(isOpen: boolean | undefined): number | undefined {
    const [zIndex, setZIndex] = useState<number | undefined>();

    useLayoutEffect(() => {
        if (!isOpen) return;
        const z = claimZIndex();
        setZIndex(z);
        return () => {
            releaseZIndex(z);
        };
    }, [isOpen]);

    return zIndex;
}
